import { useContent } from '@/content';

export default function Footer() {
  const c = useContent();
  const mailSubject = 'Anfrage über Gesichtszauber – Behandlung / Termin';
  const mailBody = `Hallo Sonja,

ich interessiere mich für:

– Ihre Behandlung / Beratung: [z. B. Microneedling, Mesoporation, Fruchtsäurepeeling ...]
– Mein Wunschtermin: [bitte eintragen]

Zu mir: [kurze Info zu Ihrem Anliegen oder Hauttyp]

Mit freundlichen Grüßen
[Ihr Name]`;

  const contactMailto = `mailto:${c.footer.email}?subject=${encodeURIComponent(mailSubject)}&body=${encodeURIComponent(mailBody)}`;
  const telHref = `tel:${c.footer.phone.replace(/[^+\d]/g, '')}`;
  const mapsQuery = encodeURIComponent(c.footer.address);

  return (
    <footer className="bg-white border-t border-blush-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <p className="font-script text-3xl text-champagne-500 mb-1">{c.footer.brand}</p>
            <p className="text-xs tracking-[0.3em] uppercase text-gray-400 font-medium">{c.footer.name}</p>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8 text-sm text-gray-500">
            <a
              href={contactMailto}
              className="hover:text-champagne-500 transition-colors flex items-center gap-2"
              title="E-Mail mit Vorlage öffnen"
            >
              <span className="w-8 h-8 flex items-center justify-center"><i className="ri-mail-line text-lg"></i></span>
              {c.footer.email}
            </a>
            <a
              href={telHref}
              className="hover:text-champagne-500 transition-colors flex items-center gap-2"
            >
              <span className="w-8 h-8 flex items-center justify-center"><i className="ri-phone-line text-lg"></i></span>
              {c.footer.phone}
            </a>
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${mapsQuery}`}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="hover:text-champagne-500 transition-colors flex items-center gap-2"
            >
              <span className="w-8 h-8 flex items-center justify-center"><i className="ri-map-pin-line text-lg"></i></span>
              {c.footer.address}
            </a>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-blush-50 text-center">
          <p className="text-xs text-gray-400">
            &copy; {new Date().getFullYear()} {c.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
}